/**
 * usePutPiAttestations — PUT /v1/clinics/{clinic_id}/promoting-interop
 *
 * Replace-all semantics, identical pattern to IA. Powers the Promoting
 * Interoperability score-card edit modal.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getApiClient } from "@/api/client";
import type { PiAttestationRequest, PiAttestationResponse } from "@/api/models";
import { queryKeys } from "./queryKeys";

export function usePutPiAttestations(clinicId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: PiAttestationRequest): Promise<PiAttestationResponse> => {
      const { data } = await getApiClient().put<PiAttestationResponse>(
        `/v1/clinics/${clinicId}/promoting-interop`,
        body,
      );
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.dashboard.byClinic(clinicId) });
    },
  });
}
